export default "__VITE_ASSET__De70TK7$__"